module.exports = __webpack_public_path__ + "assets/img/21_58.1bed1197.jpg";